import React from 'react';

const SubscriptionsIcon = () => {
  return (
    <svg className="platform-icon allservices-icon" width="28" height="28" viewBox="0 0 42 42">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-31">
          <path
            d="M31.5,0 L10.5,0 C4.70101013,0 0,4.70101013 0,10.5 L0,31.5 C0,37.2989899 4.70101013,42 10.5,42 L31.5,42 C37.2989899,42 42,37.2989899 42,31.5 L42,10.5 C42,4.70101013 37.2989899,0 31.5,0 Z"
            id="Path-Copy"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <g id="Group-32" transform="translate(8.000000, 8.000000)">
            <g id="Group-30">
              <circle id="Oval-Copy-3" stroke="#FFFFFF" cx="13" cy="13" r="13"></circle>
              <path
                d="M0,26 C7.17970175,26 13,20.1797017 13,13 C13,5.82029825 7.17970175,0 0,0"
                id="Oval"
                stroke="#EE0000"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(6.500000, 13.000000) rotate(-180.000000) translate(-6.500000, -13.000000) "
              ></path>
            </g>
            <g id="Group-28" transform="translate(4.000000, 4.000000)">
              <circle id="Oval-Copy-4" stroke="#FFFFFF" cx="9" cy="9" r="9"></circle>
              <path
                d="M9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 C4.02943725,0 0,4.02943725 0,9"
                id="Oval"
                stroke="#EE0000"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(9.000000, 9.000000) rotate(-180.000000) translate(-9.000000, -9.000000) "
              ></path>
            </g>
          </g>
          <path d="M17,20.746988 L20.1640625,24 L26,18" id="Path-2" stroke="#FFFFFF" strokeWidth="1.15"></path>
        </g>
      </g>
    </svg>
  );
};
export default SubscriptionsIcon;
